export var CSSUnit;
(function (CSSUnit) {
    CSSUnit["PIXEL"] = "px";
    CSSUnit["PERCENT"] = "%";
    CSSUnit["EM"] = "em";
})(CSSUnit || (CSSUnit = {}));
